var _style, _path, _path2, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconV(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 140 141.6",
    style: {
      enableBackground: "new 0 0 140 141.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.16;fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st1{opacity:0.7;fill:url(#SVGID_1_);enable-background:new    ;}\r\n\t.st2{opacity:0.7;fill:url(#SVGID_00000097476599781631138580000015159294300728562064_);enable-background:new    ;}\r\n\t.st3{opacity:0.5;}\r\n\t.st4{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133,63.6C129.2,28.8,97.9,3.7,63.1,7.5S3.1,42.6,7,77.4s35.1,59.9,69.9,56.1S136.8,98.4,133,63.6z M70,122.7 c-28.8,0-52.1-23.3-52.1-52.1S41.2,18.4,70,18.4s52.1,23.3,52.1,52.1S98.8,122.7,70,122.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -7495.5796,
    y1: -1619.7936,
    x2: -7421.4126,
    y2: -1619.7936,
    gradientTransform: "matrix(-0.6445 0.6445 -0.7071 -0.7071 -5873.1045 3733.093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    style: {
      stopColor: "#EBE8EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDF3F7"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69,95.2l34.3-34.3c3.7-3.7,3.7-9.8,0-13.5l0,0c-3.7-3.7-9.8-3.7-13.5,0L55.5,81.7c-3.7,3.7-3.7,9.8,0,13.5l0,0 C59.2,99,65.3,99,69,95.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162345336520358574290000006967892972823559609_",
    gradientUnits: "userSpaceOnUse",
    x1: 693.3126,
    y1: 3554.988,
    x2: 767.5818,
    y2: 3554.988,
    gradientTransform: "matrix(0.4174 0.4174 0.7071 -0.7071 -2765.3206 2288.6433)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    style: {
      stopColor: "#EBE8EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDF3F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000162345336520358574290000006967892972823559609_)",
      enableBackground: "new"
    },
    d: " M55.3,95.2L37.8,77.8c-3.7-3.7-3.7-9.8,0-13.5l0,0c3.7-3.7,9.8-3.7,13.5,0l17.5,17.5c3.7,3.7,3.7,9.8,0,13.5l0,0 C65.1,99,59,99,55.3,95.2z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.2,7.4c-10.3,0.8-20.6,4.1-29.9,10.2c-27,17.6-36,52.5-22.1,80.8l9.8-5.6c-12.1-25.4-1.8-56,23.5-68.8 c6.3-3.2,12.9-5,19.5-5.5L65.2,7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M13,99.1l-0.2-0.5C-1.5,69.8,8.1,34.7,35.1,17.1c9-5.9,19.4-9.4,30.1-10.2h0.5L66.5,19H66 c-6.7,0.5-13.2,2.4-19.3,5.4C34.6,30.5,25.6,41,21.2,53.8s-3.6,26.6,2.2,38.7l0.2,0.4L13,99.1z M64.7,7.9 c-10.3,0.9-20.4,4.3-29.1,10C9.3,35.2-0.2,69.4,13.4,97.7l8.9-5.1c-5.7-12.3-6.5-26.2-2.1-39.1c4.4-13.1,13.7-23.7,26-30 c6-3.1,12.5-4.9,19.2-5.5L64.7,7.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.1,98.3c-1.6,2.2-0.3,0.5-0.4,0.7c-16,24-48.3,30.5-72.3,14.5c-7.2-4.8-12.8-11.1-16.7-18.2l-9.5,6.1 c5.8,10.3,14.6,19.2,26,25c29.1,15.1,64.6,5.3,82.2-21.5L114.1,98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M70.4,134.1c-10,0-20-2.3-29.5-7.2c-11-5.7-20.1-14.4-26.2-25.2l-0.2-0.4l10.4-6.6l0.3,0.5 c4,7.4,9.6,13.4,16.6,18.1c23.5,15.6,55.2,9.5,71.1-13.7c0.1-0.2,0.3-0.6,0.9-1.4l0.3-0.4l9.9,7.1l-0.3,0.4 C111.5,123.8,91.2,134.1,70.4,134.1z M15.8,101.5c6,10.4,14.8,18.9,25.5,24.4c28.6,14.8,63.4,5.8,81.2-21l-8.3-6l-0.2,0.3 c-16.1,24.2-48.8,30.7-73,14.7c-6.9-4.6-12.5-10.7-16.6-17.9L15.8,101.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M69,18.5C69.3,18.5,69.2,18.5,69,18.5L69,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.5,19v-1.1H69c0.2,0,0.7,0,0.7,0.5s-0.5,0.5-0.7,0.5L68.5,19z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M132.9,61.9C128.5,29.8,100.7,6.6,69,7.2v11.2c28.6-0.6,52.4,22,53.2,50.7c0.3,9.4-2,18.2-6.1,25.9l9.1,6.8 C131.9,90.1,134.9,76.2,132.9,61.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M125.4,102.6l-9.9-7.4l0.2-0.4c4.2-7.9,6.3-16.7,6-25.7C120.9,40.9,97.3,18.3,69,18.9h-0.5V6.7H69 c32.3-0.6,60,23.1,64.4,55.1c1.9,14-0.7,27.9-7.7,40.2L125.4,102.6z M116.8,94.9l8.3,6.2c6.7-12,9.2-25.5,7.3-39.1l0,0 c-4.3-31.1-30.9-54.3-62.2-54.3c-0.2,0-0.4,0-0.7,0v10.2c0.2,0,0.4,0,0.6,0c28.3,0,51.8,22.7,52.6,51.2 C123,78,120.9,87,116.8,94.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconV);
export default __webpack_public_path__ + "static/media/icon_v.35236776726d5dca8cbad1792029cb8d.svg";
export { ForwardRef as ReactComponent };